import React, { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import {
  SIGNING_COMPLETE_SOURCE,
  SIGNING_COMPLETE_TYPE,
} from "src/types/integrations/docusign";
import styles from "./styles.module.scss";

const DocusignSigningComplete = () => {
  const { assetId } = useParams();
  const [searchParams] = useSearchParams();
  const envelopeId = searchParams.get("envelopeId") || "";
  const event = searchParams.get("event") || "";

  useEffect(() => {
    if (window.parent === window || !assetId || !envelopeId) {
      return;
    }

    const payload = {
      source: SIGNING_COMPLETE_SOURCE,
      type: SIGNING_COMPLETE_TYPE,
      assetId: assetId || "",
      envelopeId,
      event,
    };

    window.parent.postMessage(payload, window.location.origin);

    // DocuSign may load this page before the parent listener is ready.
    const retryTimer = window.setTimeout(() => {
      window.parent.postMessage(payload, window.location.origin);
    }, 500);

    return () => window.clearTimeout(retryTimer);
  }, [assetId, envelopeId, event]);

  return <div className={styles.container}>Returning to asset viewer...</div>;
};

export default DocusignSigningComplete;
